var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGumroad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 12.6289H21.9818V21.4807H17.9943L17.9671 12.6289M17.9693 13.0178C17.9693 17.3569 15.7429 21.9959 10.9967 21.9959C6.25041 21.9959 2.01758 18.6591 2.01758 12.3935C2.01758 6.12782 5.86966 2.00403 12.2353 2.00403C18.6009 2.00403 21.467 5.96425 21.467 9.19203H16.8016C16.8016 7.70082 15.1823 5.47535 12.2353 5.47535C9.28828 5.47535 6.54756 8.08066 6.54756 12C6.54756 15.9193 8.66307 18.4974 11.9999 18.4974C15.3367 18.4974 17.3159 15.2232 17.3159 12.6279",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGumroad);
export default __webpack_public_path__ + "static/media/gumroad.ac784b0693e40447968c4ec71975dadb.svg";
export { ForwardRef as ReactComponent };